import { Box, Skeleton } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import type { Image } from "../imagesPreview/ImagePreview";
import { storageUrlWithCredentials } from "../imagesPreview/storageUrlWithCredentials";

interface ImagePreviewProps {
  readonly image: Omit<Image, "tags" | "products" | "id" | "www" | "isPrivate" | "flavours">;
  readonly size?: number;
  readonly width?: number;
  readonly height?: number;
}

const ImagePreview: FC<ImagePreviewProps> = ({ image, size, width = size, height = size }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);

  const openImage = async () => {
    const signedUrl = await storageUrlWithCredentials(image.original.url);
    window.open(signedUrl, "_blank");
  };

  useEffect(() => {
    storageUrlWithCredentials(image.thumbnail.url).then((url) => setThumbnailUrl(url ?? null));
  }, [image.thumbnail.url]);
  return (
    <Box sx={{ flexShrink: 0 }}>
      {thumbnailUrl ? (
        <img
          srcSet={thumbnailUrl}
          src={thumbnailUrl}
          alt={image.name}
          loading="lazy"
          onClick={openImage}
          height={height}
          width={width}
          style={{ objectFit: "cover", display: "block" }}
        />
      ) : (
        <Skeleton variant="rectangular" width={width} height={height} />
      )}
    </Box>
  );
};

export default ImagePreview;
